import {deleteHeaders, fetchHeaders, patchHeaders, postHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";

export const agencesService = {
    fetchAgences,
    fetchAgence,
    createAgence,
    updateAgence,
    deleteAgence,
}

function fetchAgences() {
    const requestOptions = fetchHeaders();
    return fetch(Constants.API_ROUTE_AGENCES, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return Array.isArray(data) ? data : data['hydra:member'];
        });
}

function fetchAgence(id) {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_AGENCE.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then((agence) => {
            return agence;
        });
}

function createAgence(values) {
    const requestOptions = postHeaders(values);
    return fetch(Constants.API_ROUTE_AGENCES, requestOptions)
        .then(handleResponse)
        .then((agence) => {
            return agence;
        });
}

function updateAgence(id, values) {
    const requestOptions = patchHeaders(values);
    const url = Constants.API_ROUTE_AGENCE.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then((agence) => {
            return agence;
        });
}

function deleteAgence(id) {
    const requestOptions = deleteHeaders();
    const url = Constants.API_ROUTE_AGENCE.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return "ok";
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
